import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import { searchPOSPatients } from 'actions/EntityActions';
import { idOrderHistoryDialog } from 'actions/EntityActions';
import { linkPatientToOrder, initializeStorePOSPatient, formInput, clearFormInput } from 'actions/FormActions';
import { showError } from 'actions/CommonActions';
import { selectPOSPatientSearchModel } from 'selectors/entitySelector';
import MaskedTextInput from 'screens/components/advanced/MaskedTextInput';
import Pagination from 'screens/components/basic/Pagination';
import DialogInput from 'screens/components/advanced/DialogInput';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import CheckInput from 'screens/components/basic/CheckInput';
import { Divider } from '@mui/material';
import POSOrderHistory from './POSOrderHistory';
import { getPatientOrders } from 'actions/EntityActions';
import DialogHeader from 'screens/components/basic/DialogHeader';
import POSPatientSave from './POSPatientSave';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

const statusList = 'LIST';

const dialogStyle = {
    width: '70%',
    maxWidth: 'none'
};

class POSPatient extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isAdditionalInformationOpen: false,
            additionalInformation: null,
            status: statusList,
            activePage: 1,
            itemsPerPage: 5,
            showOrderHistoryDialog: false,
            editMemberOpen: false,
            selectedMemberId: 0
        };

        this.search = this.search.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (this.props.isOpen === false && newProps.isOpen === true) {
            this.props.initializeStorePOSPatient();
        }
    }

    search = (page = 1) => {
        let filter = this.props.patientSearchModel;
        filter.page = page;
        filter.itemsPerPage = this.state.itemsPerPage;
        filter.branchId = this.props.branchId;
        let blockedList = ["unknown", "guest"];
        if (filter.firstName != null && blockedList.includes(filter.firstName.replace(/[^a-zA-Z]+/g, "").toLowerCase())) {
            this.props.showError(this.props.t('pos.patient.validNameErrorMessage'))
        }
        else if (filter.lastName != null && blockedList.includes(filter.lastName.replace(/[^a-zA-Z]+/g, "").toLowerCase())) {
            this.props.showError(this.props.t('pos.patient.validNameErrorMessage'))
        }
        else if (filter.preferredName != null && blockedList.includes(filter.preferredName.replace(/[^a-zA-Z]+/g, "").toLowerCase())) {
            this.props.showError(this.props.t('pos.patient.validNameErrorMessage'))
        }
        else {
            this.props.search(filter);
        }
    }

    pageChange = (page) => {
        this.setState({ activePage: page });
        this.search(page);
    }

    linkPatientToOrder = (patient) => {
        this.props.clearFormInput('POSPatientIdentificationType');
        this.props.clearFormInput('POSPatientIdentificationNumber');
        this.props.linkPatientToOrder(patient);
        this.props.onClose();
    }

    showOrderHistory = (id) => {
        this.props.setIDOrderHistory(id);
        this.getOrders(id);
        this.setState({ showOrderHistoryDialog: true });
    }

    onClose = () => {
        this.props.initializeStorePOSPatient();
        this.props.onClose();
        this.props.formInput("", "POSPatientCardNumber")
    }

    getOrders = (id) => {
        const model = {
            branchId: 0,
            orderNumber: null,
            orderDate: null,
            patientFirstName: "",
            employeeFirstName: "",
            status: 'None',
            total: null,
            orderBy: "DESC",
            sortBy: "Id",
            innerClass: "",
            employeeId: null,
            patientId: id,
            page: 1,
            itemsPerPage: 10
        }

        this.props.getPatientOrders(model);
    }

    onAdditionalInformationClose = () => {
        this.setState({ isAdditionalInformationOpen: false, additionalInformation: null });
    }

    openAdditionalInformationDialog = (notes) => {
        this.setState({ isAdditionalInformationOpen: true, additionalInformation: notes });
    }

    openEditMemberDialog = (memberId) => {
        this.setState({ editMemberOpen: true, selectedMemberId: memberId });
    }

    closeEditMemberDialog = () => {
        this.setState({ editMemberOpen: false, selectedMemberId: 0 });
    }

    onKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.target.blur();
            this.search();
        }
    }

    closeOrderHistoryDialog = () => {
        this.setState({ showOrderHistoryDialog: false })
    }

    render() {
        const { t } = this.props; 
        const p = this.props;
        const s = this.state;

        const hideBCRewards = this.props.store && this.props.store.provinceState && (this.props.store.provinceState.toLowerCase() == "bc" || this.props.store.provinceState.toLowerCase() == "british columbia") && !this.props.isMedical;

        const actions = [
            <Button
                key={1}
                type="CancelButton"
                className="btn-space"
                label={t('common.cancel')}
                secondary={true}
                onTouchTap={() => this.onClose()}
            />,
            <Button
                key={2}
                id="searchButton"
                className="pull-right btn-space btnNewBrandPOS"
                type="RaisedButton"
                label={t('common.search')}
                onTouchTap={() => this.search()}
            />
        ];

        const patients = p.posPatients.map((item, index) => {
            return (
                <div key={index}>
                    <div className="media">
                        {item.photo && <div className="media-left media-top">
                            <img src={item.photo} className="media-object media-photo" />
                        </div>}
                        <div className="media-body">
                            <h6 className="media-heading">{`${item.firstName} ${item.lastName} ${item.preferredName ? ' (' + item.preferredName + ')' : ''}`} <span className="pull-right">{item.dateOfBirth}</span></h6>
                            <p>{t('common.member')} #{item.id}</p>
                            <p>{item.notes}</p>
                            {!hideBCRewards && <p>{t('pos.patient.visitCount')}: {item.visitCount}</p>}

                            {!this.props.springbigApiKey && !this.props.alpineIQApiKey && !hideBCRewards && <p>{t('pos.patient.rewardPoints')} {item.rewardPoints}</p>}

                            <Button
                                className="pull-right btnNewBrandPOS"
                                id="linkToOrderButton"
                                type="RaisedButton"
                                label={t('pos.patient.addToOrderButton')}
                                onTouchTap={() => this.linkPatientToOrder(item)}
                            />
                            {
                                item.additionalInformation ? (
                                    <Button
                                        type="FlatButtonPrimary"
                                        name="openNotes"
                                        className="btnNewBrandPOS"
                                        label={t('pos.patient.readNotes')}
                                        onTouchTap={() => this.openAdditionalInformationDialog(item.additionalInformation)} />
                                ) : null
                            }
                            <Button
                                type="RaisedButton"
                                className="btnNewBrandPOS ml-1"
                                label={t('pos.patient.viewOrderButton')}
                                onTouchTap={() => this.showOrderHistory(item.id)}
                            />
                            <br />
                            <br />
                            <Button
                                type="FlatButtonPrimary"
                                label={t('pos.patient.viewMemberButton')}
                                onTouchTap={() => this.openEditMemberDialog(item.id)}
                            />
                        </div>
                    </div>
                    <br />
                    <Divider />
                    <br />
                </div>
            );
        });

        return (
            <React.Fragment>
                <DialogInput
                    title={<DialogHeaderWithClose text={t('pos.patient.memberSearch')} classicClass="posDialogClassic" handleClose={() => this.onClose()} />}
                    actions={actions}
                    modal={true}
                    open={p.isOpen}
                    autoScrollBodyContent={true}
                    contentStyle={dialogStyle}>
                    <div className="form-group">
                        <div className="row">
                            <div className="col-lg-12">
                                <TextInput name={p.name + "CardNumber"}
                                    label={t('common.cardNum')}
                                    floatingLabelText={t('common.cardNum')}
                                    hintText={t('pos.patient.inputCardNumber')}
                                    onKeyPress={this.onKeyPress}
                                    fullWidth={true}
                                    autoComplete="off"
                                />
                            </div>
                            <div className="col-lg-6">
                                <TextInput name={p.name + "FirstName"}
                                    label={t('common.firstName')}
                                    floatingLabelText={t('common.firstName')}
                                    hintText={t('pos.patient.typeFirstName')}
                                    onKeyPress={this.onKeyPress}
                                    fullWidth={true}
                                    autoComplete="off"
                                />
                            </div>
                            <div className="col-lg-6">
                                <TextInput name={p.name + "LastName"}
                                    label={t('common.lastName')}
                                    floatingLabelText={t('common.lastName')}
                                    hintText={t('pos.patient.typeLastName')}
                                    onKeyPress={this.onKeyPress}
                                    fullWidth={true}
                                    autoComplete="off"
                                />
                            </div>
                            <div className="col-lg-6">
                                <TextInput name={p.name + "PreferredName"}
                                    label={t('common.preferredName')}
                                    floatingLabelText={t('common.preferredName')}
                                    hintText={t('pos.patient.typePreferredName')}
                                    onKeyPress={this.onKeyPress}
                                    fullWidth={true}
                                    autoComplete="off"
                                />
                            </div>
                            <div className="col-lg-6">
                                <TextInput name={p.name + "Email"}
                                    label={t('common.email')}
                                    floatingLabelText={t('common.email')}
                                    hintText={t('pos.patient.typeEmail')}
                                    onKeyPress={this.onKeyPress}
                                    fullWidth={true}
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <TextInput name={p.name + "MemberNumber"}
                                    type="number"
                                    label={t('common.patientNumber')}
                                    floatingLabelText={t('common.patientNumber')}
                                    hintText={t('pos.patient.typeMemberNumber')}
                                    onKeyPress={this.onKeyPress}
                                    autoFocus={true}
                                    fullWidth={true}
                                    autoComplete="off"
                                />
                            </div>
                            <div className="col-lg-6">
                                <MaskedTextInput
                                    fullWidth={true}
                                    name={`${p.name}Phone`}
                                    floatingLabelText={t('common.phone')}
                                    hintText={t('pos.patient.typePhone')}
                                    onKeyPress={this.onKeyPress}
                                    mask="(999) 999-9999"
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <CheckInput name={p.name + "IsNotMember"} text={t('pos.patientDialog.isNotMember')} className="d-inline-block checkBoxLabels" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                {
                                    patients && patients.length > 0 ?
                                        (
                                            <div>
                                                <h4>{t('common.members')}</h4>
                                                <p className="text-grey"><b>{t('common.note')}: </b><i>{t('pos.patient.readdProduct')}</i></p>
                                                <Divider />
                                                <br />
                                            </div>
                                        ) : null
                                }
                                {patients}
                                <Pagination
                                    length={p.posPatientsLength || 0}
                                    itemsPerPage={s.itemsPerPage}
                                    activePage={s.activePage}
                                    onPageChange={(e) => this.pageChange(e)} />
                            </div>
                        </div>
                    </div>
                </DialogInput>

                <POSOrderHistory isOpen={this.state.showOrderHistoryDialog} onCancel={() => this.closeOrderHistoryDialog()} />

                <DialogInput
                    title={<DialogHeader text={t('pos.patient.memberAdditionInfo')} />}
                    actions={
                        <Button
                            type="CancelButton"
                            className="btn-space"
                            label={t('common.close')}
                            secondary={true}
                            onTouchTap={() => this.onAdditionalInformationClose()}
                        />}
                    modal={true}
                    open={s.isAdditionalInformationOpen}
                    autoScrollBodyContent={true}
                    contentStyle={dialogStyle}>
                    <div className="row">
                        <div className="col-lg-12" style={{ whiteSpace: 'pre-line' }}>
                            <br />
                            <p>{s.additionalInformation}</p>
                        </div>
                    </div>
                </DialogInput>
                <POSPatientSave isOpen={this.state.editMemberOpen} onCancel={() => this.closeEditMemberDialog()} patientId={this.state.selectedMemberId} />
            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        patientSearchModel: selectPOSPatientSearchModel(state, ownProps.name),
        posPatients: state.entity.posPatients,
        posPatientsLength: state.entity.posPatientsLength,
        posOrder: state.entity.posOrder,
        branchId: state.common.branchId,
        patientId: state.entity.idOrderHistoryDialog,
        store: state.common.store,
        springbigApiKey: state.common.applicationSettings.springbigApiKey || "",
        alpineIQApiKey: state.common.applicationSettings.alpineIQApiKey || "",
        isMedical: state.common.applicationSettings.isMedical
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        search: (filter) => dispatch(searchPOSPatients(filter)),
        linkPatientToOrder: (patient) => dispatch(linkPatientToOrder(patient, ownProps.name)),
        initializeStorePOSPatient: () => dispatch(initializeStorePOSPatient(ownProps.name)),
        setIDOrderHistory: (id) => dispatch(idOrderHistoryDialog(id)),
        getPatientOrders: (model) => dispatch(getPatientOrders(model)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSPatient));
